// SheetStateButton.js
import React, { useState } from 'react';
import { Button, Box } from "grommet";

const SheetStateButton = ({ evaluationMaxGrade, el, openSheet }) => {
    const [isHovered, setIsHovered] = useState(false);
    // console.log('el  >>  ', el);

    return (
        <Button 
            onMouseOver={() => {
                setIsHovered(true);
            }}
            onFocus={() => {
                setIsHovered(true);
            }}            
            onMouseLeave={() => {
                setIsHovered(false);
            }}                                   

            style={{
                padding: 0,
                boxShadow: isHovered
                    // This entire block is the "value if true" for isHovered
                    ? (
                        (evaluationMaxGrade !== 0 && el.evaluationGrade === evaluationMaxGrade)
                            ? '0px 0px 0px 2px #f0869c'
                            : (!el.EvaluationId
                                ? '0px 0px 0px 2px #666666'
                                : `0px 0px 0px 2px ${el.sheetColor}`
                            )
                    )
                    // This is the "value if false" for isHovered
                    : 'none',                                     
                borderStyle: 'solid',
                borderWidth: '2px' ,
                borderColor: (evaluationMaxGrade !== 0 && el.evaluationGrade === evaluationMaxGrade) 
                    ? '#f0869c' 
                    : (!el.EvaluationId ? '#666666' : `${el.sheetColor}`),
   
                transition: 'box-shadow 0.2s ease-in-out', // Adds a smooth effect
                borderRadius: evaluationMaxGrade !== 0 && el.evaluationGrade === evaluationMaxGrade ? 'xxlarge' : undefined,
                background: 
                    evaluationMaxGrade !== 0 && el.evaluationGrade === evaluationMaxGrade 
                    ? `radial-gradient(${el.sheetColor} 60%, ${el.sheetColor} 60%, #f0869c 98%)` 
                    : el.sheetColor,
                whiteSpace: 'pre-wrap',
                // whiteSpace: 'nowrap',
                lineBreak: "strict", 
                color: el.sheetFontColor || '#00739D',  // Use the default color if el.sheetFontColor is undefined or empty                 
            }}                                    

            label={el.sheetName}
            onClick={() => openSheet(el)}
        />
  );
};

export default SheetStateButton;